import { Button, ButtonStyle } from '@atlas/components';
import type { FC } from 'react';

import Icon from 'components/Icon/Icon';
import { useClientProfile } from 'store';
import { AUTH_PAGES, useAuthRedirects } from 'utils/authRedirects';
import { Translation } from 'utils/translations';

import type { PopupProps } from './types';

import styles from './LogoutPopup.module.scss';

const LogoutPopup: FC<PopupProps> = ({ closePopup }) => {
  const [_, { logout }] = useClientProfile();
  const { redirectToAuthPage } = useAuthRedirects();

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles['close-button']}
        onClick={closePopup}
        data-testid="close"
      >
        <Icon name="close.outline" width={24} height={24} />
      </button>
      <h3 className={styles.title}>
        <Translation message="log_out_modal_title" />
      </h3>
      <p className={styles.text}>
        <Translation message="log_out_modal_text" />
      </p>
      <div className={styles.buttons}>
        <Button
          onClick={() => {
            logout();
            closePopup();
            redirectToAuthPage(AUTH_PAGES.signIn);
          }}
          style={ButtonStyle.outline}
          data-testid="logout"
        >
          <Translation message="log_out_modal_button_logout" />
        </Button>
        <Button onClick={closePopup} data-testid="cancel">
          <Translation message="log_out_modal_button_close" />
        </Button>
      </div>
    </div>
  );
};

export default LogoutPopup;
